module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAABFCAYAAADevW+tAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gIIDhochp7gOAAAAMxJREFUaN7t2k0OgjAQhuG3DXvuoJfihnop7qAnGHfGvyAGWyh5Z9nVk6FM2+RLh9MFgHHog+1XAsgNgQECIEVEK+B7ZRqs7tPi8XxNtQDj0M/aEpOdrgn+5edrfnuIFi1atGjRokWLFi1atGjRokWLFi1atGjRokWLFi1atOi1yuiE6L2h30IqtfMeM0Iq8BJU2U8caGHnovTXy6XBU+tOD9GiHXnPo+1xWpQ4rLoSnSh9qubSM/UPFd6nV0NvMMX79bWV17iOLgED3AAnRjRA77nT5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/shouji_denglu_white_icon@3x.png
// module id = 661
// module chunks = 0